import React, { useEffect, useState } from 'react'
import { Loader2, Play, RefreshCw, StopCircle } from 'lucide-react'
import type { ScanStatusPanelProps } from './types'
import styles from '../../pages/DocumentsPage.module.css'
import { useScanControls } from './hooks/useScanControls'


export const ScanStatusPanel: React.FC<ScanStatusPanelProps> = ({
  stage,
  scanStatus,
  statusMessage,
  canStartScan,
  hasClassifications,
  caseId,
  caseData,
}) => {
    const { isStartingScan, isCanceling, handleStartScan, handleCancelScan, isScanStarted } = useScanControls(caseId, caseData)
    const [showCancelConfirm, setShowCancelConfirm] = useState(false)


    useEffect(() => {
      setShowCancelConfirm(false)
    }, [caseId])



  return (
    <div className={styles.scanAction}>
      {(scanStatus === 'scanning') || isScanStarted ? (
        <div className={styles.scanningState}>
          <div className={styles.scanProgress}>
            <Loader2 size={14} className={styles.spinner} />
            <span>{statusMessage}</span>
          </div>
          {showCancelConfirm ? (
            <div className={styles.cancelConfirmInline}>
              <button onClick={handleCancelScan} disabled={isCanceling} className={styles.cancelYes}>
                {isCanceling ? 'Stopping...' : 'Stop'}
              </button>
              <button onClick={() => setShowCancelConfirm(false)} className={styles.cancelNo}>Keep</button>
            </div>
          ) : (
            <button className={styles.cancelBtn} onClick={() => setShowCancelConfirm(true)}>
              <StopCircle size={12} /> Cancel
            </button>
          )}
        </div>
      ) : (
        <button
          className={styles.scanBtn}
          onClick={handleStartScan}
          disabled={!canStartScan || isStartingScan}
        >
          {isStartingScan ? (
            <><Loader2 size={14} className={styles.spinner} /> Scanning...</>
          ) : hasClassifications ? (
            <><RefreshCw size={14} /> Rescan All</>
          ) : (
            <><Play size={14} /> Start Scan</>
          )}
        </button>
      )}
    </div>
  )
}

